import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
import DashboardTable from "../../components/table/DashboardTable";
import DashboardPagination from "../../components/pagination/DashboardPagination";
import { sortArrow } from "../../assets/images/project-images";
import UserService from "../../services/user";
import "./Brands.scss";
import axios from "../../libs/axios";
import { useHistory } from "react-router-dom";
import { useQuery } from "react-query";
// import axios from "axios";
import PrimaryButton from "../../components/button/PrimaryButton";
import { Select } from "antd";
import config from "../../config";
import BrandEdit from "./BrandEdit";
// import CardEdit from "./cardsEdit";

const Brands = () => {
  const [users, setusers] = useState([]);
  const [id, setid] = useState("");
  const [addbrand, setaddbrand] = useState(false);
  const [brandData, setbrandData] = useState([]);
  const [cardDetail, setcardDetail] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  const [clientData, setclientData] = useState([]);
  const [isModalOpen, setisModalOpen] = useState(false);
  const [message, setmessage] = useState("");
  const getBrandsData = async () => {
    try {
      const response = await axios.get(`/brand/all`);
      setbrandData(response?.data?.data);
    } catch (error) {
      setbrandData([]);
      console.error("Error fetching data:", error?.message);
    }
  };

  useEffect(() => {
    getBrandsData();
  }, []);

  const columns = [
    {
      title: <div className="cursor-pointer">Name</div>,
      dataIndex: "name",
      key: "name",
      render: (name) => <p className="darkBlue">{name ? name : "Null"}</p>,
    },

    {
      title: <div className="cursor-pointer">Discount</div>,
      dataIndex: "discount",
      key: "discount",
    },
    {
      title: <div className="cursor-pointer">Discount Type</div>,
      dataIndex: "discountType",
      key: "discountType",
      render: (name) => <p className="darkBlue">{name ? name : "NULL"}</p>,
    },

    {
      title: <div className="cursor-pointer">Approved</div>,
      dataIndex: "approved",
      key: "approved",
      render: (name) => <p className="darkBlue">{name === true ? "true" : "false"}</p>,
    },
    {
      title: <div className="cursor-pointer">Is Active</div>,
      dataIndex: "isActive",
      key: "isActive",
      render: (name) => <p className="darkBlue">{name === true ? "true" : "false"}</p>,
    },
    {
      title: <div className="cursor-pointer">Created At</div>,
      dataIndex: "createdAt",
      key: "createdAt",
      render: (name) => <p className="darkBlue">{name.slice(0, 10)}</p>,
    },
    {
      title: "",
      dataIndex: "isActive",
      key: "isActive",
      render: (id, record) =>
        id === true ? (
          <PrimaryButton
            title="Disable"
            className="unblock-btn capitalize"
            onClick={async () => {
              setid(record);
              setisModalOpen(true);
              setmessage("disable");
              setaddbrand(false);
              // setaddcategory(false);
            }}
          />
        ) : (
          <PrimaryButton
            title="Enable"
            className="unblock-btn capitalize"
            onClick={async () => {
              setid(record);
              setisModalOpen(true);
              setmessage("enable");
              setaddbrand(false);

              // setaddcategory(false);
            }}
          />
        ),
    },
  ];

  const page = parseInt(urlParams.get("page")) || 1;
  const history = useHistory();

  const handlePageChange = (page1) => {
    history.push(`?page=${page1}`);
  };

  return (
    <>
      <div
        className="dashboard-heading"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h2 className="darkGray font-light">Brands</h2>
        <PrimaryButton
          title="Add Brand"
          onClick={() => {
            setisModalOpen(true);
            setid("");
            setaddbrand(true);
          }}
        />
      </div>
      <div className="dashboard-table sorting-table">
        <DashboardTable
          data={brandData}
          columns={columns}
          onRow={(data, rowIndex) => {
            return {
              onClick: () => {
                // history.push(`/clientDetail?id=${data.id}`);
                // console.log(data, rowIndex);
                // setisModalOpen(true);
                // setcardDetail(true);
              },
            };
          }}
        />
      </div>
      {clientData?.results?.length > 0 && (
        <DashboardPagination
          current={clientData?.page}
          total={clientData?.totalResults}
          pageSize={clientData?.limit}
          onChange={handlePageChange}
        />
      )}
      {isModalOpen && (
        <BrandEdit
          id={id}
          getBrandsData={getBrandsData}
          addbrand={addbrand}
          message={message}
          isModalOpen={isModalOpen}
          setisModalOpen={setisModalOpen}
        />
      )}
    </>
  );
};

export default Brands;
